/* De La Terre — Global Runtime Core v3A
   Externalizado do theme.liquid para reduzir HTML repetido e permitir cache.
   Mantém tracking e checkout intent; R1-A preserva /cart como página independente. */
(function () {
  'use strict';

  if (window.__dltGlobalRuntimeInstalled) return;
  window.__dltGlobalRuntimeInstalled = true;

  /*
    DLT P1.25.3 — compatibilidade defensiva do carrinho lazy.
    Alguns scripts/cache antigos podem chamar estes helpers antes de
    dlt-cart-drawer.js terminar de carregar. Os shims evitam ReferenceError
    sem forcar o bundle do carrinho na primeira dobra; o runtime real
    sobrescreve estas funcoes assim que fica disponivel.
  */
  if (typeof window.getStoredDiscountCodes !== 'function') {
    window.getStoredDiscountCodes = function () {
      try {
        return String(window.sessionStorage.getItem('dlt_cart_discount_codes') || window.__dltCartDiscountCodes || '');
      } catch (error) {
        return String(window.__dltCartDiscountCodes || '');
      }
    };
  }
  if (typeof window.syncCartCountLabels !== 'function') {
    window.syncCartCountLabels = function () { return false; };
  }
  if (typeof window.scheduleCartCountLabelSync !== 'function') {
    window.scheduleCartCountLabelSync = function () { return false; };
  }

  /* DLT P1.3.4.1 — integridade dos cupons oficiais.
     Protege somente hosts que exibem códigos promocionais. Cada host guarda
     seu HTML correto e recebe um observer local; não há MutationObserver global. */
  var DLT_OFFICIAL_COUPONS = ['BEMVINDO10', 'NOVOAQUI15'];
  var dltCouponHostObservers = new WeakMap();

  function dltCouponTokenRegex() {
    return /(BEMVINDO10|NOVOAQUI15)/g;
  }

  function dltWrapOfficialCouponTokens(host) {
    if (!host || !host.querySelectorAll) return false;

    var official = host.getAttribute('data-dlt-official-coupon');
    if (official && DLT_OFFICIAL_COUPONS.indexOf(official) !== -1) {
      if (host.textContent !== official) host.textContent = official;
      host.classList.add('notranslate');
      host.setAttribute('translate', 'no');
      return true;
    }

    var walker = document.createTreeWalker(host, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        if (!node || !node.nodeValue) return NodeFilter.FILTER_REJECT;
        var parent = node.parentElement;
        if (!parent) return NodeFilter.FILTER_REJECT;
        if (parent.closest('[data-dlt-official-coupon]')) return NodeFilter.FILTER_REJECT;
        return dltCouponTokenRegex().test(node.nodeValue)
          ? NodeFilter.FILTER_ACCEPT
          : NodeFilter.FILTER_REJECT;
      }
    });

    var nodes = [];
    var current;
    while ((current = walker.nextNode())) nodes.push(current);

    nodes.forEach(function (textNode) {
      var text = textNode.nodeValue;
      var fragment = document.createDocumentFragment();
      var regex = dltCouponTokenRegex();
      var lastIndex = 0;
      var match;

      while ((match = regex.exec(text))) {
        if (match.index > lastIndex) {
          fragment.appendChild(document.createTextNode(text.slice(lastIndex, match.index)));
        }

        var span = document.createElement('span');
        span.className = 'notranslate';
        span.setAttribute('translate', 'no');
        span.setAttribute('data-dlt-official-coupon', match[1]);
        span.textContent = match[1];
        fragment.appendChild(span);
        lastIndex = regex.lastIndex;
      }

      if (lastIndex < text.length) {
        fragment.appendChild(document.createTextNode(text.slice(lastIndex)));
      }

      textNode.parentNode.replaceChild(fragment, textNode);
    });

    return host.querySelector('[data-dlt-official-coupon]') !== null;
  }

  function dltWatchCouponHost(host) {
    if (!host || dltCouponHostObservers.has(host)) return;
    if (!dltWrapOfficialCouponTokens(host)) return;

    var originalHtml = host.innerHTML;
    var restoring = false;
    var observer = new MutationObserver(function () {
      if (restoring) return;

      var invalid = false;
      host.querySelectorAll('[data-dlt-official-coupon]').forEach(function (node) {
        var expected = node.getAttribute('data-dlt-official-coupon');
        if (DLT_OFFICIAL_COUPONS.indexOf(expected) === -1 || node.textContent !== expected) {
          invalid = true;
        }
      });

      if (!invalid && host.innerHTML === originalHtml) return;

      restoring = true;
      host.innerHTML = originalHtml;
      restoring = false;
    });

    observer.observe(host, { childList: true, characterData: true, subtree: true });
    dltCouponHostObservers.set(host, observer);
  }

  function dltProtectOfficialCouponCodes(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var hosts = [];

    if (scope.matches && scope.matches('[data-dlt-coupon-host]')) hosts.push(scope);
    scope.querySelectorAll('[data-dlt-coupon-host]').forEach(function (host) {
      hosts.push(host);
    });

    hosts.forEach(dltWatchCouponHost);
  }

  window.dltProtectOfficialCouponCodes = dltProtectOfficialCouponCodes;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      dltProtectOfficialCouponCodes(document);
    }, { once: true });
  } else {
    dltProtectOfficialCouponCodes(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    dltProtectOfficialCouponCodes(event && event.target ? event.target : document);
  });
  document.addEventListener('cart:refresh', function () {
    dltProtectOfficialCouponCodes(document);
  });
  document.addEventListener('cart:change', function () {
    dltProtectOfficialCouponCodes(document);
  });

  function getCurrency() {
    var config = window.__dltGlobalRuntimeConfig || {};
    return config.currency ||
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
      'BRL';
  }

/*
        DLT Fase 26 — tracking leve para INP.
        Mantém APIs globais usadas por checkout/carrinho, mas remove o wrapper de fetch duplicado.
        A captura de add_to_cart agora fica centralizada no toast global, evitando dois response.clone().json()
        para a mesma interação.
      */
      window.delaterreTracking = window.delaterreTracking || {};

      window.delaterreTracking.nextEventMeta = function(eventName) {
        var fallbackId = [eventName, Date.now(), Math.floor(Math.random() * 1000000)].join("_");

        if (window.themeTracking && typeof window.themeTracking.nextEventMeta === "function") {
          var themeEventMeta = window.themeTracking.nextEventMeta(eventName) || {};
          return {
            event_source: themeEventMeta.event_source || "theme_checkout_mode",
            event_id: themeEventMeta.event_id || fallbackId
          };
        }

        return {
          event_source: "theme_checkout_mode",
          event_id: fallbackId
        };
      };

      window.delaterreTracking.pushEvent = function(eventName, payload) {
        window.dataLayer = window.dataLayer || [];

        var meta = window.delaterreTracking.nextEventMeta(eventName);
        var eventPayload = {
          event: eventName,
          event_source: meta.event_source,
          event_id: meta.event_id
        };

        if (payload && typeof payload === "object") {
          Object.keys(payload).forEach(function(key) {
            eventPayload[key] = payload[key];
          });
        }

        window.dataLayer.push(eventPayload);
        return eventPayload;
      };

      /*
        DLT P1.25.1 — ponte oficial Theme -> Shopify Customer Events.
        Eventos personalizados do tema sao publicados com namespace dlt:* para que
        Pixels Personalizados possam assina-los sem religar GTM/gtag no storefront.
        O dataLayer acima continua apenas como camada de compatibilidade/debug.
      */
      window.delaterreTracking.publishShopifyEvent = function(eventName, payload) {
        try {
          if (
            window.Shopify &&
            window.Shopify.analytics &&
            typeof window.Shopify.analytics.publish === "function"
          ) {
            var publishResult = window.Shopify.analytics.publish(eventName, payload || {});

            if (publishResult && typeof publishResult.catch === "function") {
              publishResult.catch(function(error) {
                if (window.console && typeof window.console.warn === "function") {
                  console.warn("[tracking] Shopify.analytics.publish rejected", eventName, error);
                }
              });
            }

            return publishResult;
          }
        } catch (error) {
          if (window.console && typeof window.console.warn === "function") {
            console.warn("[tracking] Shopify.analytics.publish failed", eventName, error);
          }
        }

        return false;
      };

      /*
        DLT P1.25.3 — ponte leve para Microsoft Clarity.
        Nao cria snippet, fila ou cookie e nao contorna consentimento:
        so envia quando o app embed oficial ja disponibilizou window.clarity.
        Assim o tracking comportamental nunca bloqueia UX nem duplica o Clarity.
      */
      window.delaterreTracking.clarityEvent = function(eventName, tags) {
        if (!eventName || typeof window.clarity !== 'function') return false;

        try {
          if (tags && typeof tags === 'object') {
            Object.keys(tags).forEach(function(key) {
              var value = tags[key];
              if (value === null || typeof value === 'undefined' || value === '') return;
              if (typeof value === 'object' || typeof value === 'function') return;
              window.clarity('set', String(key), String(value));
            });
          }

          window.clarity('event', String(eventName));
          return true;
        } catch (error) {
          return false;
        }
      };

      /*
        DLT P1.25.4 — favoritos determinísticos.
        A Shopify Web Pixels API não possui evento padrão de wishlist; portanto o tema
        publica eventos customizados namespaced e mantém o Clarity como camada
        comportamental. A captura é centralizada no evento interno dlt:wishlist-updated,
        evitando listeners adicionais em cada card/section e sem qualquer request extra.
      */
      window.delaterreTracking.readWishlist = function() {
        try {
          var value = JSON.parse(window.localStorage.getItem('dlt-wishlist') || '[]');
          return Array.isArray(value) ? value : [];
        } catch (error) {
          return [];
        }
      };

      window.delaterreTracking.normalizeWishlistItem = function(item) {
        if (item === null || typeof item === 'undefined') return null;

        if (typeof item === 'string' || typeof item === 'number') {
          var legacyToken = String(item);
          return legacyToken ? {
            product_id: '',
            product_handle: '',
            legacy_token: legacyToken
          } : null;
        }

        if (typeof item !== 'object') return null;

        var productId = item.id !== null && typeof item.id !== 'undefined'
          ? String(item.id)
          : '';
        var handle = item.handle !== null && typeof item.handle !== 'undefined'
          ? String(item.handle)
          : '';

        if (!productId && !handle) return null;

        return {
          product_id: productId,
          product_handle: handle,
          legacy_token: ''
        };
      };

      window.delaterreTracking.wishlistItemMatches = function(left, right) {
        var a = window.delaterreTracking.normalizeWishlistItem(left);
        var b = window.delaterreTracking.normalizeWishlistItem(right);
        if (!a || !b) return false;

        if (a.product_id && b.product_id && a.product_id === b.product_id) return true;
        if (a.product_handle && b.product_handle && a.product_handle === b.product_handle) return true;
        if (a.legacy_token && b.legacy_token && a.legacy_token === b.legacy_token) return true;

        if (a.legacy_token) {
          if (a.legacy_token === b.product_id || a.legacy_token === b.product_handle) return true;
        }
        if (b.legacy_token) {
          if (b.legacy_token === a.product_id || b.legacy_token === a.product_handle) return true;
        }

        return false;
      };

      window.delaterreTracking.getWishlistSource = function() {
        var path = String(window.location && window.location.pathname || '');
        if (path.indexOf('/pages/lista-de-desejos') !== -1 || path.indexOf('/pages/page-wishlist') !== -1) {
          return 'wishlist_page';
        }
        if (path.indexOf('/collections/') !== -1) return 'collection';
        if (path.indexOf('/products/') !== -1) return 'product';
        if (path === '/' || path === '') return 'home';
        return 'storefront';
      };

      window.delaterreTracking.getWishlistProductTitle = function(item) {
        var normalized = window.delaterreTracking.normalizeWishlistItem(item);
        if (!normalized || !document || !document.querySelectorAll) return '';

        try {
          var nodes = document.querySelectorAll('[data-product-id], [data-product-handle]');
          for (var index = 0; index < nodes.length; index += 1) {
            var node = nodes[index];
            var nodeId = String(node.getAttribute('data-product-id') || '');
            var nodeHandle = String(node.getAttribute('data-product-handle') || '');
            var matches = (normalized.product_id && nodeId === normalized.product_id)
              || (normalized.product_handle && nodeHandle === normalized.product_handle);
            if (!matches) continue;

            var title = String(node.getAttribute('data-product-title') || '').trim();
            if (title) return title;
          }
        } catch (error) {}

        return '';
      };

      window.delaterreTracking.trackWishlistMutation = function(action, item, wishlistCount) {
        var normalized = window.delaterreTracking.normalizeWishlistItem(item);
        if (!normalized) return false;

        var isAdd = action === 'add';
        var source = window.delaterreTracking.getWishlistSource();
        var productTitle = window.delaterreTracking.getWishlistProductTitle(item);
        var itemId = normalized.product_id || normalized.product_handle || normalized.legacy_token;
        var payload = {
          source: source,
          product_id: normalized.product_id || '',
          product_handle: normalized.product_handle || '',
          product_title: productTitle,
          wishlist_count: Number(wishlistCount || 0),
          page_path: String(window.location && window.location.pathname || '')
        };

        window.delaterreTracking.pushEvent(isAdd ? 'dlt_debug_add_to_wishlist' : 'dlt_debug_remove_from_wishlist', {
          trigger_source: source,
          ecommerce: {
            currency: getCurrency(),
            items: [{
              item_id: itemId,
              item_name: productTitle || normalized.product_handle || normalized.legacy_token || itemId,
              quantity: 1
            }]
          },
          dlt: {
            wishlist_count: payload.wishlist_count,
            product_handle: payload.product_handle
          }
        });

        window.delaterreTracking.publishShopifyEvent(
          isAdd ? 'dlt:wishlist_add' : 'dlt:wishlist_remove',
          payload
        );

        window.delaterreTracking.clarityEvent(
          isAdd ? 'dlt_wishlist_add' : 'dlt_wishlist_remove',
          {
            dlt_wishlist_source: source,
            dlt_wishlist_count: payload.wishlist_count,
            dlt_product_id: payload.product_id,
            dlt_product_handle: payload.product_handle
          }
        );

        return true;
      };

      window.delaterreTracking.handleWishlistUpdated = function() {
        var previous = Array.isArray(window.delaterreTracking._wishlistSnapshot)
          ? window.delaterreTracking._wishlistSnapshot
          : [];
        var current = window.delaterreTracking.readWishlist();

        var added = current.filter(function(item) {
          return !previous.some(function(oldItem) {
            return window.delaterreTracking.wishlistItemMatches(item, oldItem);
          });
        });

        var removed = previous.filter(function(item) {
          return !current.some(function(newItem) {
            return window.delaterreTracking.wishlistItemMatches(item, newItem);
          });
        });

        window.delaterreTracking._wishlistSnapshot = current.slice();

        added.forEach(function(item) {
          window.delaterreTracking.trackWishlistMutation('add', item, current.length);
        });
        removed.forEach(function(item) {
          window.delaterreTracking.trackWishlistMutation('remove', item, current.length);
        });
      };

      if (!window.delaterreTracking._wishlistTrackingBound) {
        window.delaterreTracking._wishlistTrackingBound = true;
        window.delaterreTracking._wishlistSnapshot = window.delaterreTracking.readWishlist();

        window.addEventListener('dlt:wishlist-updated', function() {
          window.delaterreTracking.handleWishlistUpdated();
        });

        var dltTrackWishlistView = function() {
          if (window.delaterreTracking._wishlistViewTracked) return;
          if (window.delaterreTracking.getWishlistSource() !== 'wishlist_page') return;

          window.delaterreTracking._wishlistViewTracked = true;
          var wishlist = window.delaterreTracking.readWishlist();
          var payload = {
            source: 'wishlist_page',
            wishlist_count: wishlist.length,
            page_path: String(window.location && window.location.pathname || '')
          };

          window.delaterreTracking.publishShopifyEvent('dlt:wishlist_view', payload);
          window.delaterreTracking.clarityEvent('dlt_wishlist_view', {
            dlt_wishlist_count: wishlist.length
          });
        };

        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', dltTrackWishlistView, { once: true });
        } else {
          window.setTimeout(dltTrackWishlistView, 0);
        }
      }


      /*
        DLT P1.25.5 — eventos semânticos de ações de alto valor.

        Objetivo:
        - publicar apenas ações relevantes para ecommerce/CRO;
        - preservar os eventos padrão da Shopify como verdade transacional;
        - não transformar cada clique visual em evento de negócio;
        - não enviar PII (email, telefone, endereço, termo digitado etc.);
        - nunca bloquear navegação, formulário ou botão.
      */
      window.delaterreTracking.publishDltAction = function(actionName, payload, clarityName) {
        if (!actionName) return false;

        var safePayload = {};
        if (payload && typeof payload === 'object') {
          Object.keys(payload).forEach(function(key) {
            var value = payload[key];
            if (value === null || typeof value === 'undefined') return;
            if (typeof value === 'object' || typeof value === 'function') return;
            safePayload[key] = value;
          });
        }

        var eventName = String(actionName);
        if (eventName.indexOf('dlt:') !== 0) {
          eventName = 'dlt:' + eventName.replace(/^dlt[_:]/, '');
        }

        window.delaterreTracking._recentSemanticActions = window.delaterreTracking._recentSemanticActions || {};
        var dedupeKey = eventName + '|' + String(safePayload.source || '') + '|' + String(safePayload.product_id || '') + '|' + String(safePayload.variant_id || '');
        var now = Date.now();
        var lastAt = Number(window.delaterreTracking._recentSemanticActions[dedupeKey] || 0);
        if (now - lastAt < 450) return false;
        window.delaterreTracking._recentSemanticActions[dedupeKey] = now;

        try {
          window.delaterreTracking.publishShopifyEvent(eventName, safePayload);
        } catch (error) {}

        try {
          window.delaterreTracking.clarityEvent(
            clarityName || eventName.replace(':', '_'),
            safePayload
          );
        } catch (error) {}

        return true;
      };

      if (!window.delaterreTracking._semanticActionTrackingBound) {
        window.delaterreTracking._semanticActionTrackingBound = true;

        /* Abrir busca — search_submitted continua sendo o evento padrão de sucesso. */
        document.addEventListener('click', function(event) {
          var target = event && event.target;
          if (!target || typeof target.closest !== 'function') return;

          var searchTrigger = target.closest('[aria-controls="search-drawer"]');
          if (searchTrigger) {
            window.delaterreTracking.publishDltAction('search_open', {
              source: 'header_search',
              page_path: String(window.location && window.location.pathname || '')
            }, 'dlt_search_open');
            return;
          }

          var whatsappLink = target.closest('a[href*="wa.me/"], a[href*="api.whatsapp.com/"], a[href*="whatsapp.com/"]');
          if (whatsappLink) {
            var whatsappSource = 'storefront';
            if (whatsappLink.closest('.whatsapp-button-container, .dlt-whatsapp-float, [data-dlt-whatsapp-float]')) whatsappSource = 'floating_button';
            else if (whatsappLink.closest('[class*="b2b"], [id*="b2b"]')) whatsappSource = 'b2b';
            else if (whatsappLink.closest('footer')) whatsappSource = 'footer';

            window.delaterreTracking.publishDltAction('whatsapp_click', {
              source: whatsappSource,
              page_path: String(window.location && window.location.pathname || '')
            }, 'dlt_whatsapp_click');
          }
        }, true);

        /* Newsletter — só registra intenção de envio, nunca o email digitado. */
        document.addEventListener('submit', function(event) {
          var form = event && event.target;
          if (!form || typeof form.querySelector !== 'function') return;

          var tagsInput = form.querySelector('input[name="contact[tags]"]');
          var tags = tagsInput ? String(tagsInput.value || '').toLowerCase() : '';
          if (tags.indexOf('newsletter') === -1) return;

          var source = 'newsletter';
          if (form.closest && form.closest('[class*="popup"], [id*="popup"]')) source = 'newsletter_popup';
          else if (form.closest && form.closest('footer, [class*="footer"]')) source = 'newsletter_footer';
          else if (form.closest && form.closest('[class*="blog"]')) source = 'newsletter_blog';

          window.delaterreTracking.publishDltAction('newsletter_submit', {
            source: source,
            page_path: String(window.location && window.location.pathname || '')
          }, 'dlt_newsletter_submit');
        }, true);

        /* PDP — registra intenção do botão sem substituir product_added_to_cart. */
        document.addEventListener('dlt:pdp:purchase:start', function(event) {
          var detail = event && event.detail && typeof event.detail === 'object' ? event.detail : {};
          var isBuyNow = !!detail.checkout;

          window.delaterreTracking.publishDltAction(
            isBuyNow ? 'pdp_buy_now_intent' : 'pdp_add_to_cart_intent',
            {
              source: String(detail.source || 'dlt-buy-box'),
              product_id: detail.productId !== null && typeof detail.productId !== 'undefined' ? String(detail.productId) : '',
              variant_id: detail.variantId !== null && typeof detail.variantId !== 'undefined' ? String(detail.variantId) : '',
              quantity: Number(detail.quantity || 1),
              page_path: String(window.location && window.location.pathname || '')
            },
            isBuyNow ? 'dlt_pdp_buy_now_intent' : 'dlt_pdp_add_to_cart_intent'
          );
        });

        /* Erro da ação PDP: útil para QA/CRO, sem bloquear a mensagem visual do buy-box. */
        document.addEventListener('dlt:pdp:purchase:error', function(event) {
          var detail = event && event.detail && typeof event.detail === 'object' ? event.detail : {};
          window.delaterreTracking.publishDltAction('pdp_cart_error', {
            source: String(detail.source || 'dlt-buy-box'),
            product_id: detail.productId !== null && typeof detail.productId !== 'undefined' ? String(detail.productId) : '',
            variant_id: detail.variantId !== null && typeof detail.variantId !== 'undefined' ? String(detail.variantId) : '',
            quantity: Number(detail.quantity || 1),
            page_path: String(window.location && window.location.pathname || '')
          }, 'dlt_pdp_cart_error');
        });
      }

      window.delaterreTracking.fetchCart = function() {
        var rootPath = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : "/";

        return fetch(rootPath + "cart.js", {
          cache: "no-store",
          credentials: "same-origin"
        }).then(function(response) {
          if (!response.ok) {
            throw new Error("cart.js returned " + response.status);
          }

          return response.json();
        });
      };

      window.delaterreTracking.buildGa4Items = function(cart) {
        if (!cart || !Array.isArray(cart.items)) {
          return [];
        }

        return cart.items.map(function(item) {
          return {
            item_id: String(item.variant_id || item.product_id || item.id || ""),
            item_name: item.product_title || item.title || "",
            item_variant: item.variant_title || "",
            item_brand: item.vendor || "",
            item_category: item.product_type || "",
            price: Number(item.final_price || item.price || 0) / 100,
            quantity: Number(item.quantity || 0) || 1
          };
        });
      };

      window.delaterreTracking.trackAddToCart = function(addedItem, triggerSource) {
        if (!addedItem || typeof addedItem !== "object") {
          return;
        }

        var quantity = Number(addedItem.quantity || 0) || 1;
        var itemPrice = Number(addedItem.final_price || addedItem.price || 0);
        var currency = addedItem.currency || getCurrency();
        var now = Date.now();

        window.delaterreTracking._recentAddToCartEvents = window.delaterreTracking._recentAddToCartEvents || {};

        Object.keys(window.delaterreTracking._recentAddToCartEvents).forEach(function(key) {
          if (now - Number(window.delaterreTracking._recentAddToCartEvents[key] || 0) > 5000) {
            delete window.delaterreTracking._recentAddToCartEvents[key];
          }
        });

        var dedupeKey = [
          String(addedItem.variant_id || addedItem.product_id || addedItem.id || ""),
          String(quantity),
          String(itemPrice),
          String(triggerSource || "cart_add_fetch")
        ].join("|");

        var lastTrackedAt = Number(window.delaterreTracking._recentAddToCartEvents[dedupeKey] || 0);
        if (now - lastTrackedAt < 1200) {
          return;
        }

        window.delaterreTracking._recentAddToCartEvents[dedupeKey] = now;

        window.delaterreTracking.pushEvent("dlt_debug_add_to_cart", {
          trigger_source: triggerSource || "cart_add_fetch",
          ecommerce: {
            currency: currency,
            value: itemPrice / 100,
            items: [{
              item_id: String(addedItem.variant_id || addedItem.product_id || addedItem.id || ""),
              item_name: addedItem.product_title || addedItem.title || "",
              item_variant: addedItem.variant_title || "",
              item_brand: addedItem.vendor || "",
              item_category: addedItem.product_type || "",
              price: itemPrice / 100,
              quantity: quantity
            }]
          }
        });

        window.delaterreTracking.clarityEvent('dlt_add_to_cart', {
          dlt_cart_source: triggerSource || 'cart_add_fetch',
          dlt_cart_qty: quantity
        });
      };

      window.delaterreTracking.bindCartNetworkTracking = function() {
        /*
          Compatibilidade legada:
          antes este método criava um wrapper de window.fetch.
          Na Fase 26 ele fica como no-op, pois o add_to_cart é tratado no wrapper único
          do dltGlobalToast para reduzir trabalho na interação.
        */
        return false;
      };

      window.delaterreTracking.trackViewCart = function(triggerSource, openId, openedAt) {
        var normalizedOpenId = String(openId || "");
        var normalizedOpenedAt = Number(openedAt || 0) || Date.now();
        var now = Date.now();

        window.delaterreTracking._recentViewCartOpenIds = window.delaterreTracking._recentViewCartOpenIds || {};

        Object.keys(window.delaterreTracking._recentViewCartOpenIds).forEach(function(key) {
          if (now - Number(window.delaterreTracking._recentViewCartOpenIds[key] || 0) > 15000) {
            delete window.delaterreTracking._recentViewCartOpenIds[key];
          }
        });

        if (normalizedOpenId && window.delaterreTracking._recentViewCartOpenIds[normalizedOpenId]) {
          return Promise.resolve(false);
        }

        if (normalizedOpenId) {
          window.delaterreTracking._recentViewCartOpenIds[normalizedOpenId] = now;
        }

        /* Clarity registra a abertura sem esperar cart.js. */
        window.delaterreTracking.clarityEvent('dlt_cart_open', {
          dlt_cart_source: triggerSource || 'unknown'
        });

        return window.delaterreTracking.fetchCart().then(function(cart) {
          var currency = cart.currency || getCurrency();
          var value = Number(cart.total_price || 0) / 100;
          var items = window.delaterreTracking.buildGa4Items(cart);
          var eventPayload = window.delaterreTracking.pushEvent("dlt_debug_view_cart", {
            trigger_source: triggerSource || "unknown",
            cart_open_id: normalizedOpenId,
            cart_token: cart.token || "",
            item_count: Number(cart.item_count || 0),
            total_price: Number(cart.total_price || 0),
            currency: currency,
            ecommerce: {
              currency: currency,
              value: value,
              items: items
            }
          });

          window.delaterreTracking._activeCartView = {
            open_id: normalizedOpenId,
            opened_at: normalizedOpenedAt,
            trigger_source: triggerSource || "unknown",
            cart_token: cart.token || "",
            item_count: Number(cart.item_count || 0),
            currency: currency,
            value: value
          };

          window.delaterreTracking.publishShopifyEvent("dlt:view_cart", {
            event_id: eventPayload && eventPayload.event_id || "",
            event_source: eventPayload && eventPayload.event_source || "theme_checkout_mode",
            trigger_source: triggerSource || "unknown",
            cart_open_id: normalizedOpenId,
            opened_at: normalizedOpenedAt,
            cart_token: cart.token || "",
            item_count: Number(cart.item_count || 0),
            currency: currency,
            value: value,
            items: items
          });

          return true;
        }).catch(function(error) {
          if (window.console && typeof window.console.warn === "function") {
            console.warn("[tracking] view_cart dispatch failed", error);
          }
          return false;
        });
      };

      /*
        O drawer emite dlt:cart-view em toda transicao real fechado -> aberto.
        Esta ponte desacopla o runtime visual do tracking e tambem cobre a abertura
        via drawer.show(), nao apenas window.openCartDrawer().
      */
      window.delaterreTracking.handleCartViewSignal = function(detail) {
        detail = detail && typeof detail === "object" ? detail : {};

        if (
          window.__dltPendingCartView &&
          detail.open_id &&
          window.__dltPendingCartView.open_id === detail.open_id
        ) {
          window.__dltPendingCartView = null;
        }

        return window.delaterreTracking.trackViewCart(
          detail.source || "cart_drawer_open",
          detail.open_id || "",
          detail.timestamp || detail.opened_at || 0
        );
      };

      document.addEventListener("dlt:cart-view", function(event) {
        window.delaterreTracking.handleCartViewSignal(event && event.detail);
      });

      /*
        DLT P1.25.2 — fechamento do cart drawer como evento customizado.
        Não existe evento GA4/Shopify padrão para "fechar carrinho"; por isso o
        namespace dlt:* é preservado e nenhum novo Google/Meta loader é criado.
      */
      window.delaterreTracking.trackCloseCart = function(detail) {
        detail = detail && typeof detail === "object" ? detail : {};

        var active = window.delaterreTracking._activeCartView || {};
        var normalizedOpenId = String(detail.open_id || active.open_id || "");
        var closedAt = Number(detail.closed_at || 0) || Date.now();
        var openedAt = Number(detail.opened_at || active.opened_at || 0);
        var durationMs = Number(detail.duration_ms || 0);

        if (!durationMs && openedAt > 0) {
          durationMs = Math.max(0, closedAt - openedAt);
        }

        window.delaterreTracking._recentCloseCartOpenIds = window.delaterreTracking._recentCloseCartOpenIds || {};

        if (normalizedOpenId && window.delaterreTracking._recentCloseCartOpenIds[normalizedOpenId]) {
          return false;
        }

        if (normalizedOpenId) {
          window.delaterreTracking._recentCloseCartOpenIds[normalizedOpenId] = closedAt;
        }

        Object.keys(window.delaterreTracking._recentCloseCartOpenIds).forEach(function(key) {
          if (closedAt - Number(window.delaterreTracking._recentCloseCartOpenIds[key] || 0) > 60000) {
            delete window.delaterreTracking._recentCloseCartOpenIds[key];
          }
        });

        var eventPayload = window.delaterreTracking.pushEvent("dlt_close_cart", {
          trigger_source: detail.source || "cart_drawer_hide",
          cart_open_id: normalizedOpenId,
          opened_at: openedAt,
          closed_at: closedAt,
          duration_ms: durationMs,
          cart_token: active.cart_token || "",
          item_count: Number(active.item_count || 0),
          currency: active.currency || getCurrency(),
          value: Number(active.value || 0)
        });

        window.delaterreTracking.publishShopifyEvent("dlt:close_cart", {
          event_id: eventPayload && eventPayload.event_id || "",
          event_source: eventPayload && eventPayload.event_source || "theme_checkout_mode",
          trigger_source: detail.source || "cart_drawer_hide",
          cart_open_id: normalizedOpenId,
          opened_at: openedAt,
          closed_at: closedAt,
          duration_ms: durationMs,
          cart_token: active.cart_token || "",
          item_count: Number(active.item_count || 0),
          currency: active.currency || getCurrency(),
          value: Number(active.value || 0)
        });

        window.delaterreTracking.clarityEvent('dlt_cart_close', {
          dlt_cart_source: detail.source || 'cart_drawer_hide',
          dlt_cart_items: Number(active.item_count || 0),
          dlt_cart_duration_bucket: durationMs < 5000 ? '0-5s' : (durationMs < 15000 ? '5-15s' : (durationMs < 60000 ? '15-60s' : '60s+'))
        });

        if (!active.open_id || !normalizedOpenId || String(active.open_id) === normalizedOpenId) {
          window.delaterreTracking._activeCartView = null;
        }

        return true;
      };

      window.delaterreTracking.handleCartCloseSignal = function(detail) {
        detail = detail && typeof detail === "object" ? detail : {};

        if (
          window.__dltPendingCartClose &&
          detail.open_id &&
          window.__dltPendingCartClose.open_id === detail.open_id
        ) {
          window.__dltPendingCartClose = null;
        }

        return window.delaterreTracking.trackCloseCart(detail);
      };

      document.addEventListener("dlt:cart-close", function(event) {
        window.delaterreTracking.handleCartCloseSignal(event && event.detail);
      });

      if (window.__dltPendingCartView && typeof window.__dltPendingCartView === "object") {
        var pendingCartView = window.__dltPendingCartView;
        var pendingAge = Date.now() - Number(pendingCartView.timestamp || 0);

        window.__dltPendingCartView = null;

        if (pendingAge >= 0 && pendingAge <= 10000) {
          window.setTimeout(function() {
            window.delaterreTracking.handleCartViewSignal(pendingCartView);
          }, 0);
        }
      }

      if (window.__dltPendingCartClose && typeof window.__dltPendingCartClose === "object") {
        var pendingCartClose = window.__dltPendingCartClose;
        var pendingCloseAge = Date.now() - Number(pendingCartClose.closed_at || 0);

        window.__dltPendingCartClose = null;

        if (pendingCloseAge >= 0 && pendingCloseAge <= 10000) {
          window.setTimeout(function() {
            window.delaterreTracking.handleCartCloseSignal(pendingCartClose);
          }, 0);
        }
      }

      window.delaterreTracking.trackCheckoutIntent = function(triggerSource) {
        var source = triggerSource || 'unknown';
        var immediateEvent = window.delaterreTracking.pushEvent('dlt_debug_checkout_intent', {
          trigger_source: source
        });

        window.delaterreTracking.publishShopifyEvent('dlt:checkout_intent', {
          event_id: immediateEvent && immediateEvent.event_id || '',
          event_source: immediateEvent && immediateEvent.event_source || 'theme_checkout_mode',
          trigger_source: source,
          timestamp: Date.now()
        });

        window.delaterreTracking.clarityEvent('dlt_checkout_click', {
          dlt_checkout_source: source
        });

        /*
          Enriquecimento assíncrono: não deve atrasar a navegação.
          O evento transacional oficial continua sendo checkout_started do
          Google & YouTube / Shopify Customer Events.
        */
        return window.delaterreTracking.fetchCart().then(function(cart) {
          var sharedPayload = {
            trigger_source: source,
            cart_token: cart.token || "",
            item_count: Number(cart.item_count || 0),
            total_price: Number(cart.total_price || 0),
            currency: cart.currency || getCurrency()
          };

          window.delaterreTracking.pushEvent("dlt_debug_begin_checkout", Object.assign({}, sharedPayload, {
            ecommerce: {
              currency: cart.currency || getCurrency(),
              value: Number(cart.total_price || 0) / 100,
              items: window.delaterreTracking.buildGa4Items(cart)
            }
          }));
        }).catch(function(error) {
          if (window.console && typeof window.console.warn === "function") {
            console.warn("[tracking] checkout enrichment failed", error);
          }
          return false;
        });
      };

      window.delaterreStartCheckout = function(event, triggerEl) {
        if (event && typeof event.preventDefault === 'function') {
          event.preventDefault();
        }

        var rootPath = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
        var isDrawerTrigger = triggerEl && typeof triggerEl.closest === 'function' && !!triggerEl.closest('cart-drawer');
        var form = triggerEl && typeof triggerEl.closest === 'function' ? triggerEl.closest('form') : null;
        var trackingSource = isDrawerTrigger ? "cart_drawer_checkout_click" : form ? "cart_page_checkout_click" : "fallback_checkout_click";

        try {
          window.delaterreTracking.trackCheckoutIntent(trackingSource);
        } catch (error) {}

        /*
          Não aguarda cart.js antes de navegar.
          INP mede a resposta à interação; bloquear o checkout por tracking aumenta latência percebida.
        */
        var navigateToCheckout = function() {
          if (form && typeof form.submit === 'function') {
            var checkoutInput = form.querySelector("input[name='checkout']");

            if (!checkoutInput) {
              checkoutInput = document.createElement("input");
              checkoutInput.type = "hidden";
              checkoutInput.name = "checkout";
              checkoutInput.value = "1";
              form.appendChild(checkoutInput);
            }

            form.submit();
            return;
          }

          window.location.href = rootPath + "checkout";
        };

        if (typeof window.requestAnimationFrame === 'function') {
          window.requestAnimationFrame(navigateToCheckout);
        } else {
          window.setTimeout(navigateToCheckout, 0);
        }
      };

      (function() {
        var cartDrawerQueryParam = "open_cart_drawer";
        var isCartPath = /\/cart\/?$/.test(window.location.pathname);
        var rootPath = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : "/";

        // R1-A: /cart is an independent server-rendered destination.
        if (isCartPath) return;

        var params;

        try {
          params = new URLSearchParams(window.location.search || "");
        } catch (error) {
          return;
        }

        if (params.get(cartDrawerQueryParam) !== "1") {
          return;
        }

        function cleanUrl() {
          try {
            params.delete(cartDrawerQueryParam);
            var nextSearch = params.toString();
            var nextUrl = window.location.pathname + (nextSearch ? "?" + nextSearch : "") + window.location.hash;
            window.history.replaceState({}, document.title, nextUrl);
          } catch (error) {}
        }

        function cartPageFallback() {
          var cartPath = window.__dltGlobalRuntimeConfig && window.__dltGlobalRuntimeConfig.cartUrl;
          if (window.__dltCartNavigationStarted) return;
          window.__dltCartNavigationStarted = true;
          window.location.assign(cartPath || rootPath.replace(/\/?$/, "/") + "cart");
        }

        function tryOpen() {
          // Await the existing canonical loader; invocation alone is not success.
          if (typeof window.__dltRequestCartDrawerOpen === "function") {
            Promise.resolve(window.__dltRequestCartDrawerOpen()).then(function (opened) {
              if (opened !== false) cleanUrl();
            }).catch(cartPageFallback);
            return;
          }
          cartPageFallback();
        }

        if (document.readyState === "loading") {
          document.addEventListener("DOMContentLoaded", tryOpen, { once: true });
        } else {
          tryOpen();
        }
      })();


  /* DLT P1.6 — Toast runtime sob demanda.
     O toast completo deixou de ser avaliado na primeira dobra. Este bootstrap
     preserva o primeiro add_to_cart (tracking + feedback) e antecipa o runtime
     quando o usuário realmente entra em uma interação de carrinho/wishlist. */
  (function () {
    var toastRuntimePromise = null;
    var baseFetch = window.fetch;

    function getToastRuntimeUrl() {
      var config = window.__dltGlobalRuntimeConfig || {};
      return String(config.toastJsUrl || '');
    }

    function ensureToastRuntime() {
      if (window.__dltGlobalToastInstalled && typeof window.dltShowToast === 'function') {
        return Promise.resolve(true);
      }

      if (toastRuntimePromise) return toastRuntimePromise;

      toastRuntimePromise = new Promise(function (resolve, reject) {
        var url = getToastRuntimeUrl();
        if (!url) {
          reject(new Error('DLT toast runtime URL ausente'));
          return;
        }

        var existing = document.querySelector('script[data-dlt-toast-runtime]');
        if (existing) {
          if (window.__dltGlobalToastInstalled) {
            resolve(true);
            return;
          }

          existing.addEventListener('load', function () { cleanupToastPrewarm(); resolve(true); }, { once: true });
          existing.addEventListener('error', reject, { once: true });
          return;
        }

        var script = document.createElement('script');
        script.src = url;
        script.async = true;
        script.setAttribute('data-dlt-toast-runtime', '');
        script.addEventListener('load', function () { cleanupToastPrewarm(); resolve(true); }, { once: true });
        script.addEventListener('error', reject, { once: true });
        document.head.appendChild(script);
      }).catch(function (error) {
        toastRuntimePromise = null;
        if (window.console && typeof window.console.warn === 'function') {
          console.warn('[DLT] Toast runtime não pôde ser carregado.', error);
        }
        return false;
      });

      return toastRuntimePromise;
    }

    function showAfterRuntime(payload) {
      return ensureToastRuntime().then(function (loaded) {
        if (!loaded) return false;

        if (typeof window.dltShowToast === 'function') {
          window.dltShowToast(payload);
          return true;
        }

        window.dispatchEvent(new CustomEvent('dlt:toast', { detail: payload || {} }));
        return true;
      });
    }

    function requestUrl(input) {
      if (typeof input === 'string') return input;
      if (input && typeof input.url === 'string') return input.url;
      return '';
    }

    function requestMethod(input, init) {
      return String((init && init.method) || (input && input.method) || 'GET').toUpperCase();
    }

    function isCartAddRequest(input, init) {
      return requestMethod(input, init) === 'POST' && requestUrl(input).indexOf('/cart/add') !== -1;
    }

    function refreshCartSignals() {
      window.requestAnimationFrame(function () {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
        window.dispatchEvent(new CustomEvent('cart-update'));
      });
    }

    function cleanToastText(value) {
      return String(value || '').replace(/\s+/g, ' ').trim();
    }

    function productTitleFromCartAdd(data) {
      if (!data || typeof data !== 'object') return 'Produto';
      return cleanToastText(data.product_title || data.title || data.handle || 'Produto');
    }

    function cartDrawerIsOpen() {
      var drawer = document.querySelector('cart-drawer, #CartDrawer, #cart-drawer, .cart-drawer, [data-cart-drawer]');
      if (!drawer) return false;
      return drawer.hasAttribute('open') ||
        drawer.classList.contains('open') ||
        drawer.classList.contains('active') ||
        drawer.classList.contains('is-open') ||
        drawer.getAttribute('aria-hidden') === 'false';
    }

    function readJsonSafely(response) {
      try {
        return response.clone().json();
      } catch (error) {
        return Promise.reject(error);
      }
    }

    var TOAST_INTENT_SELECTOR =
      '[data-wishlist-toggle], .dlt-col-card__wishlist, .dlt-disc__wish-btn, ' +
      'button[name="add"], [data-action="add-to-cart"], [data-add-to-cart], ' +
      '.product-card__mobile-quick-buy-button, [data-dlt-video-add-to-cart], ' +
      'line-item-quantity input[data-line-key], line-item-quantity a[href*="/cart/change"], ' +
      '.quantity-selector__button, [data-dlt-remove-line], [data-dlt-bxgy-add], ' +
      '[data-cart-discount-form], [data-dlt-shipping-form], [data-dlt-shipping-submit]';

    var WISHLIST_INTENT_SELECTOR =
      '[data-wishlist-toggle], .dlt-col-card__wishlist, .dlt-disc__wish-btn, ' +
      '[data-product-id][data-product-handle][aria-label*="desejo"], ' +
      '[data-product-id][data-product-handle][aria-label*="favorito"], ' +
      '[aria-label*="lista de desejos"], [aria-label*="favoritos"], [aria-label*="Favoritos"]';

    var hasInitialToastIntentTargets = false;
    var hasInitialWishlistTargets = false;

    try {
      hasInitialToastIntentTargets = !!document.querySelector(TOAST_INTENT_SELECTOR);
      hasInitialWishlistTargets = !!document.querySelector(WISHLIST_INTENT_SELECTOR);
    } catch (error) {}

    function toastIntentTarget(target) {
      if (!target || typeof target.closest !== 'function') return null;
      return target.closest(TOAST_INTENT_SELECTOR);
    }

    function prewarmToastRuntime(event) {
      if (window.__dltGlobalToastInstalled) return;
      if (!toastIntentTarget(event && event.target)) return;
      ensureToastRuntime();
    }

    var toastCartOpenEvents = ['dlt:cart-view', 'cart:open', 'cart-drawer:open'];
    var toastCartWarmTimer = null;

    function prewarmToastOnCartOpen(event) {
      if (window.__dltGlobalToastInstalled || toastCartWarmTimer) return;
      var delay = event && event.type === 'dlt:cart-view' ? 0 : 140;
      toastCartWarmTimer = window.setTimeout(function () {
        toastCartWarmTimer = null;
        ensureToastRuntime();
      }, delay);
    }

    function cleanupToastPrewarm() {
      document.removeEventListener('pointerdown', prewarmToastRuntime, true);
      document.removeEventListener('focusin', prewarmToastRuntime, true);
      if (toastCartWarmTimer) {
        window.clearTimeout(toastCartWarmTimer);
        toastCartWarmTimer = null;
      }
      toastCartOpenEvents.forEach(function (eventName) {
        document.removeEventListener(eventName, prewarmToastOnCartOpen);
        window.removeEventListener(eventName, prewarmToastOnCartOpen);
      });
    }

    /*
       P1.26.0 — só instala listeners de intenção nas páginas que realmente
       contêm wishlist/add-to-cart no HTML inicial. Páginas de conteúdo, políticas
       e institucionais deixam de pagar esse custo em cada pointer/focus. O wrapper
       de fetch permanece como compatibilidade para adds injetados tardiamente.
    */
    if (hasInitialToastIntentTargets) {
      document.addEventListener('pointerdown', prewarmToastRuntime, { passive: true, capture: true });
      document.addEventListener('focusin', prewarmToastRuntime, { passive: true, capture: true });
    }

    /* Primeiro add_to_cart: o bootstrap captura a resposta antes de o toast
       completo existir. Depois que o toast instala seu próprio wrapper, este
       proxy vira somente pass-through e não duplica clone/analytics. */
    if (typeof baseFetch === 'function' && !window.__dltToastBootstrapFetchBound) {
      window.__dltToastBootstrapFetchBound = true;

      window.fetch = function (input, init) {
        var shouldBootstrapAdd = !window.__dltGlobalToastInstalled && isCartAddRequest(input, init);
        var args = arguments;

        return baseFetch.apply(this, args).then(function (response) {
          if (!shouldBootstrapAdd || !response || !response.ok) return response;

          readJsonSafely(response).then(function (data) {
            if (window.delaterreTracking && typeof window.delaterreTracking.trackAddToCart === 'function') {
              window.delaterreTracking.trackAddToCart(data, 'cart_add_bootstrap');
            }

            refreshCartSignals();
            showAfterRuntime({
              variant: 'cart',
              title: 'Adicionado ao carrinho',
              product: productTitleFromCartAdd(data),
              microcopy: 'Sua rotina De La Terre foi atualizada.',
              action: 'cart',
              buttonText: 'Ver carrinho',
              showButton: !cartDrawerIsOpen()
            });
          }).catch(function () {
            refreshCartSignals();
            showAfterRuntime({
              variant: 'cart',
              title: 'Adicionado ao carrinho',
              product: 'Produto',
              microcopy: 'Sua rotina De La Terre foi atualizada.',
              action: 'cart',
              buttonText: 'Ver carrinho',
              showButton: !cartDrawerIsOpen()
            });
          });

          return response;
        });
      };
    }

    function findWishlistButton(target) {
      if (!target || typeof target.closest !== 'function') return null;
      if (target.closest('a.dlt-header__wishlist-link, a[href*="page-wishlist"], a[href="/wishlist"]')) return null;

      return target.closest(WISHLIST_INTENT_SELECTOR);
    }

    function wishlistIsActive(button) {
      return !!button && (
        button.classList.contains('active') ||
        button.classList.contains('is-active') ||
        button.classList.contains('is-selected') ||
        button.getAttribute('aria-pressed') === 'true' ||
        button.getAttribute('data-wishlist-active') === 'true'
      );
    }

    function wishlistTitle(button) {
      if (!button) return 'Produto';
      var direct = button.getAttribute('data-product-title') || button.getAttribute('data-title') || button.getAttribute('title');
      if (direct) return cleanToastText(direct.replace(/^(Salvar|Adicionar|Remover)\s+/i, ''));

      var card = button.closest('.dlt-disc__card, .dlt-col-card, .product-card, .card, article, li');
      if (card) {
        var title = card.querySelector('.dlt-disc__name, .dlt-col-card__title, .product-card__title, .card__heading, h3, h2, a[href*="/products/"]');
        if (title && title.textContent) return cleanToastText(title.textContent);
      }

      return 'Produto';
    }

    /* Garante feedback também no primeiro clique de wishlist. O handler completo
       só é necessário depois da intenção e, portanto, sai da primeira dobra. */
    if (hasInitialWishlistTargets) {
      document.addEventListener('click', function (event) {
        if (window.__dltGlobalToastInstalled) return;
        var button = findWishlistButton(event.target);
        if (!button) return;

        var wasActive = wishlistIsActive(button);
        var title = wishlistTitle(button);

        ensureToastRuntime().then(function (loaded) {
          if (!loaded) return;
          window.setTimeout(function () {
            var isActive = wishlistIsActive(button);
            var added = isActive !== wasActive ? isActive : !wasActive;

            if (typeof window.dltShowToast === 'function') {
              window.dltShowToast({
                variant: 'wishlist',
                title: added ? 'Adicionado aos queridinhos' : 'Removido dos queridinhos',
                product: title,
                microcopy: added
                  ? 'Sua fórmula foi salva na sua curadoria De La Terre.'
                  : 'Sua curadoria De La Terre foi atualizada.',
                action: 'wishlist',
                buttonText: 'Ver queridinhos',
                showButton: true
              });
            }
          }, 180);
        });
      }, true);
    }

    /* Ao abrir o drawer, prepara o toast em background antes de alterações de
       quantidade/remoção. Não há download na carga inicial da página. */
    toastCartOpenEvents.forEach(function (eventName) {
      document.addEventListener(eventName, prewarmToastOnCartOpen, { passive: true });
      window.addEventListener(eventName, prewarmToastOnCartOpen, { passive: true });
    });

    function cartFeedbackAlreadyShown(since) {
      return Number(window.__dltLastCartToastAt || 0) >= Number(since || 0);
    }

    function firstCartUserError(result) {
      if (!result || !Array.isArray(result.userErrors) || !result.userErrors.length) return '';
      return cleanToastText(result.userErrors[0].message || 'Não foi possível atualizar o carrinho.');
    }

    function scheduleStandardCartFeedback(startedAt, payload) {
      window.setTimeout(function () {
        if (cartFeedbackAlreadyShown(startedAt)) return;
        showAfterRuntime(payload);
      }, 220);
    }

    function handleStandardCartPromise(event, payloadFactory) {
      if (!event || !event.promise || typeof event.promise.then !== 'function') return;

      var startedAt = Date.now();

      Promise.resolve(event.promise).then(function (result) {
        var userError = firstCartUserError(result);

        if (userError) {
          scheduleStandardCartFeedback(startedAt, {
            variant: 'error',
            title: 'Carrinho não atualizado',
            product: userError,
            microcopy: 'Revise a alteração e tente novamente.',
            showButton: false,
            action: ''
          });
          return;
        }

        var payload = payloadFactory(event, result || {});
        if (payload) scheduleStandardCartFeedback(startedAt, payload);
      }).catch(function (error) {
        scheduleStandardCartFeedback(startedAt, {
          variant: 'error',
          title: 'Carrinho não atualizado',
          product: cleanToastText(error && error.message) || 'Não foi possível concluir esta alteração.',
          microcopy: 'Tente novamente em instantes.',
          showButton: false,
          action: ''
        });
      });
    }

    document.addEventListener('shopify:cart:lines-update', function (event) {
      handleStandardCartPromise(event, function () {
        var action = String(event.action || 'update').toLowerCase();

        if (action === 'add') {
          return {
            variant: 'cart',
            title: 'Adicionado ao carrinho',
            product: 'Produto adicionado com sucesso.',
            microcopy: '',
            action: 'cart',
            buttonText: 'Ver carrinho',
            showButton: !cartDrawerIsOpen()
          };
        }

        if (action === 'remove') {
          return {
            variant: 'remove',
            title: 'Produto removido',
            product: 'Item removido e totais atualizados.',
            microcopy: '',
            showButton: false,
            action: 'cart'
          };
        }

        return {
          variant: 'quantity',
          title: 'Carrinho atualizado',
          product: 'Quantidade e valores recalculados.',
          microcopy: '',
          showButton: false,
          action: 'cart'
        };
      });
    });

    document.addEventListener('shopify:cart:discount-update', function (event) {
      handleStandardCartPromise(event, function () {
        var codes = Array.isArray(event.discountCodes) ? event.discountCodes : [];
        var codeText = codes.map(function (entry) {
          return cleanToastText(entry && entry.code);
        }).filter(Boolean).join(', ');

        return {
          variant: 'standard',
          title: 'Desconto atualizado',
          product: codeText ? 'Código: ' + codeText : 'Condições promocionais atualizadas.',
          microcopy: '',
          showButton: false,
          action: ''
        };
      });
    });

    document.addEventListener('shopify:cart:note-update', function (event) {
      handleStandardCartPromise(event, function () {
        return {
          variant: 'standard',
          title: 'Carrinho atualizado',
          product: 'Observações do pedido atualizadas.',
          microcopy: '',
          showButton: false,
          action: ''
        };
      });
    });

    document.addEventListener('shopify:cart:attributes-update', function (event) {
      handleStandardCartPromise(event, function () {
        return {
          variant: 'standard',
          title: 'Carrinho atualizado',
          product: 'Preferências da compra atualizadas.',
          microcopy: '',
          showButton: false,
          action: ''
        };
      });
    });

    document.addEventListener('shopify:cart:error', function (event) {
      var startedAt = Date.now();
      window.setTimeout(function () {
        if (cartFeedbackAlreadyShown(startedAt)) return;
        showAfterRuntime({
          variant: 'error',
          title: 'Carrinho não atualizado',
          product: cleanToastText(event && event.error) || 'Não foi possível concluir esta alteração.',
          microcopy: 'Tente novamente em instantes.',
          showButton: false,
          action: ''
        });
      }, 80);
    });

    window.dltEnsureToastRuntime = ensureToastRuntime;
  })();


  /* DLT P1.1 — Semantic fallback moved from theme.liquid for cacheability. */
  /*
    DLT Fase 20 — guarda semântica leve.
    A Fase 19 já corrigiu o HTML na origem; este bloco fica apenas como fallback
    para marcações legadas injetadas tardiamente, sem MutationObserver amplo.
  */
  (function () {
    function patchAgenticA11yLite() {
      var optimizer = document.querySelector('#main-page[data-optimizer="layout"]');
      if (optimizer) {
        optimizer.setAttribute('aria-hidden', 'true');
        optimizer.setAttribute('hidden', 'hidden');
      }

      document.querySelectorAll('.dlt-hv10__dots[aria-label]').forEach(function (el) {
        if (!el.matches('nav')) {
          el.setAttribute('role', 'navigation');
        }
      });

      document.querySelectorAll('a.rating[role="img"], a.dlt-static-rating[role="img"], a.dlt-v3__rating[role="img"], a.dlt-disc__rating[role="img"], button.dlt-static-rating[role="img"]').forEach(function (el) {
        el.removeAttribute('role');
      });

      document.querySelectorAll('.dlt-v3__rating[aria-label]:not(a):not(button), .dlt-client-reviews__stars[aria-label]:not(a):not(button)').forEach(function (el) {
        el.setAttribute('role', 'img');
      });

      document.querySelectorAll('.dlt-tech-banner__card[role="listitem"], .dlt-client-reviews__card[role="listitem"]').forEach(function (el) {
        el.removeAttribute('role');
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', patchAgenticA11yLite, { once: true });
    } else {
      patchAgenticA11yLite();
    }

    window.addEventListener('load', function () {
      window.setTimeout(patchAgenticA11yLite, 600);
    }, { once: true });
  })();

})();
